import { ePhongHocTrongKyActionsObj, IPhongHocTrongKyActionTypes } from "../../action-types/category/IPhongHocTrongKyActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IPhongHocTrongKyReducer } from "../../reducer-model/category/IPhongHocTrongKyReducer";

const iniState: IPhongHocTrongKyReducer = {
    status: eReducerStatusBase.is_not_initialization,
    phongHocTrongKys: [],
    selectedIdsPhongHocChuaChon: [],
    selectedIdsPhongHocDaChon: [],
};

export const phongHocTrongKyReducer = (state: IPhongHocTrongKyReducer = iniState, action: IPhongHocTrongKyActionTypes): IPhongHocTrongKyReducer => {
    switch (action.type) {
        case "PHONG_HOC_TRONG_KY_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "PHONG_HOC_TRONG_KY_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                phongHocTrongKys: action.payload,
            };
        case "PHONG_HOC_TRONG_KY_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "PHONG_HOC_TRONG_KY_ASYNC_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "PHONG_HOC_TRONG_KY_ASYNC_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "PHONG_HOC_TRONG_KY_ASYNC_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
            case "PHONG_HOC_TRONG_KY_CHANGE_SELECTED_IDS_PHONG_HOC_CHUA_CHON":
                return {
                    ...state,
                    selectedIdsPhongHocChuaChon: action.payload,
                };
            case "PHONG_HOC_TRONG_KY_CHANGE_SELECTED_IDS_PHONG_HOC_DA_CHON":
                return {
                    ...state,
                    selectedIdsPhongHocDaChon: action.payload,
                };
            case "PHONG_HOC_TRONG_KY_UPDATE_START":
                return {
                    ...state,
                    status: eReducerStatusBase.is_saving,
                };
            case "PHONG_HOC_TRONG_KY_UPDATE_SUCCESS":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed,
                    //cập nhật lại sức chứa
                    phongHocTrongKys: state.phongHocTrongKys.map(x => x.id_phong === action.payload.id_phong ? { ...x, suc_chua: action.payload.suc_chua } : x),
                };
            case "PHONG_HOC_TRONG_KY_UPDATE_ERRR":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed,
                };
        default:
            return state;
    }
}   